<template>
  <div class="pc_model-info">
    <div>
      <pc-progress
        :current="current"
        :total="total"
      ></pc-progress>
      <div class="title">{{$t('PCModelInfo.index.646yn085ljk0')}}</div>
      <pc-property-list
        ref="propertyList"
        :data="properties"
        :brandId="brandId"
        :current="current"
        :multiSelectId="multiSelectId"
        :canNotOpenOptions="canNotOpenOptions"
        @changeCurrent="changeCurrent"
        @selectAnswer="selectAnswer"
        @multiSelectAnswer="multiSelectAnswer"
        @changeQrcode="changeQrcode"
        @showAnswers="showAnswers"></pc-property-list>
      <pc-button :disabled="disabled" @handleSubmit="submit"></pc-button>
    </div>
  </div>
</template>

<script>
// import { ref, toRef, onMounted } from '@vue/composition-api'

import PCProgress from '@/components/PCProgress'
import PCPropertyList from '../PCPropertyList'
import PCButton from '@/components/PCButton'

export default {
  name: 'PCModelInfo',
  props: {
    properties: Array,
    brandId: Number,
    multiSelectId: Number,
    canNotOpenOptions: Array,
    current: Number,
    total: Number,
    disabled: Boolean
  },
  components: {
    'pc-progress': PCProgress,
    'pc-property-list': PCPropertyList,
    'pc-button': PCButton
  },
  data() {
    return {
      propertyList: null,
      // propertiesData: this.properties,
      // brandIdData: this.brandId,
      // multiSelectIdData: this.multiSelectId,
      // canNotOpenOptionsData: this.canNotOpenOptions,
      // currentData: this.current,
      // totalData: this.total,
      // disableData: this.disabled
    };
  },
  methods: {
    selectAnswer(propertyIndex, answer) {
      this.$emit('selectAnswer', propertyIndex, answer);
    },
    multiSelectAnswer(data) {
      this.$emit('multiSelectAnswer', data);
    },
    showAnswers(propertyIndex) {
      this.$emit('showAnswers', propertyIndex);
    },
    submit() {
      this.$emit('submit');
    },
    changeCurrent(data){
      this.$emit('changeCurrent', data)
    },
    changeQrcode(data) {
      this.$emit('changeQrcode', data)
    }
  }
};
</script>

<style scoped lang="less">
.pc_model-info {
  width: 880px;
  border-radius: 8px;
  padding: 24px;
  background-color: #fff;
  min-height: 572px;
  position: relative;
  .title {
    text-align: center;
    font-size: 20px;
    height: 34px;
    line-height: 34px;
    margin: 20px 0;
  }
  .sub-btn {
    position: absolute;
    bottom: 24px;
    right: 20px;
  }
}
</style>
